import { render, staticRenderFns } from "./commonContent.vue?vue&type=template&id=2e4702df&scoped=true"
import script from "./commonContent.vue?vue&type=script&lang=js"
export * from "./commonContent.vue?vue&type=script&lang=js"
import style0 from "./commonContent.vue?vue&type=style&index=0&id=2e4702df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4702df",
  null
  
)

export default component.exports